// Action Types
export const SET_PACKAGE_IDS = "SET_PACKAGE_IDS"
export const SET_ADDITIONAL_SERVICES = "SET_ADDITIONAL_SERVICES"
export const SET_UNSELECTED_PACKAGE_SERVICES = "SET_UNSELECTED_PACKAGE_SERVICES"
export const SET_UNSELECTED_ADDITIONAL_INFO = "SET_UNSELECTED_ADDITIONAL_INFO"
export const SET_OPTIONAL_ADDITIONAL_INFO = "SET_OPTIONAL_ADDITIONAL_INFO"
export const SET_UNSELECTED_MEDICAL_INFO = "SET_UNSELECTED_MEDICAL_INFO"
export const SET_OPTIONAL_MEDICAL_INFO = "SET_OPTIONAL_MEDICAL_INFO"
export const SET_POST_PACKAGE_IDS = "SET_POST_PACKAGE_IDS"
export const SET_POST_ADDITIONAL_SERVICES = "SET_POST_ADDITIONAL_SERVICES"
export const SET_POST_OPTIONAL_ADDITIONAL_INFO = "SET_POST_OPTIONAL_ADDITIONAL_INFO"
export const SET_POST_OPTIONAL_MEDICAL_INFO = "SET_POST_OPTIONAL_MEDICAL_INFO"
export const SET_POST_UNSELECTED_ADDITIONAL_INFO = "SET_POST_UNSELECTED_ADDITIONAL_INFO"
export const SET_POST_UNSELECTED_MEDICAL_INFO = "SET_POST_UNSELECTED_MEDICAL_INFO"
export const SET_POST_UNSELECTED_PACKAGE_SERVICES = "SET_POST_UNSELECTED_PACKAGE_SERVICES"

// Action Creators
export const setPackageIdsAction = (payload) => ({
  type: SET_PACKAGE_IDS,
  payload
})

export const setAdditionalServicesAction = (payload) => ({
  type: SET_ADDITIONAL_SERVICES,
  payload
})

export const setUnselectedPackageServicesAction = (payload) => ({
  type: SET_UNSELECTED_PACKAGE_SERVICES,
  payload
})

export const setUnselectedAdditionalInfoAction = (payload) => ({
  type: SET_UNSELECTED_ADDITIONAL_INFO,
  payload
})

export const setOptionalAdditionalInfoAction = (payload) => ({
  type: SET_OPTIONAL_ADDITIONAL_INFO,
  payload
})

export const setUnselectedMedicalInfoAction = (payload) => ({
  type: SET_UNSELECTED_MEDICAL_INFO,
  payload
})

export const setOptionalMedicalInfoAction = (payload) => ({
  type: SET_OPTIONAL_MEDICAL_INFO,
  payload
})

export const setPostPackageIdsAction = (payload) => ({
  type: SET_POST_PACKAGE_IDS,
  payload
})

export const setPostAdditionalServicesAction = (payload) => ({
  type: SET_POST_ADDITIONAL_SERVICES,
  payload
})

export const setPostOptionalAdditionalInfoAction = (payload) => ({
  type: SET_POST_OPTIONAL_ADDITIONAL_INFO,
  payload
})

export const setPostOptionalMedicalInfoAction = (payload) => ({
  type: SET_POST_OPTIONAL_MEDICAL_INFO,
  payload
})

export const setPostUnselectedAdditionalInfoAction = (payload) => ({
  type: SET_POST_UNSELECTED_ADDITIONAL_INFO,
  payload
})

export const setPostUnselectedMedicalInfoAction = (payload) => ({
  type: SET_POST_UNSELECTED_MEDICAL_INFO,
  payload
})

export const setPostUnselectedPackageServicesAction = (payload) => ({
  type: SET_POST_UNSELECTED_PACKAGE_SERVICES,
  payload
})

export const setPackageServiceAction = (response, type = '') => (dispatch) => {

  if (type === 'reservation') {

    const postPackageIds = response?.packages?.map((item) => ({
      ...item,
      id: item?.packageId,
      value: item?.packageId,
      label: item?.name
    }))

     // Set Package Ids
    dispatch(setPostPackageIdsAction(postPackageIds || null))

    // Set Unselected Package Services
    const unselectPackageService = response?.services?.packageServices?.filter(
      (item) => !item?.isIncluded
    )

    const mappingUnselectPackageService = unselectPackageService?.map(
      (item) => ({
        ...item,
        packageCategory: response?.packages?.find(
          (packageItem) => packageItem?.packageId === item?.packageId
        )?.packageCategory,
        projectId: response?.packages?.find(
          (packageItem) => packageItem?.packageId === item?.packageId
        )?.project?.id || null
      })
    )

    dispatch(setPostUnselectedPackageServicesAction(mappingUnselectPackageService || null))

    let services = (response?.services?.additionalServices || [])?.map((item) => ({
      ...item,
      value: item?.id,
      label: item?.name,
      type: 'general'
    }))

    let additionalServices = (response?.services?.projectAdditionalServices || [])?.map((item) => ({
      ...item,
      value: item?.id,
      label: item?.name,
      type: 'project'
    })) 

    let mergeServicesAndAdditionalServices = services?.concat(additionalServices)

    // Set Additional Services
    dispatch(setPostAdditionalServicesAction(mergeServicesAndAdditionalServices || null))

    // Set Unselected Additional Info
    const unselectAdditionalInfo = response?.packageServiceAdditionalInfo?.filter(
      (item) => !item?.isIncluded
    )
    dispatch(setPostUnselectedAdditionalInfoAction(unselectAdditionalInfo || null))

    // Set Optional Additional Info
    dispatch(setPostOptionalAdditionalInfoAction(response?.optionalAdditionalInfo))

    // Set Unselected Medical Info
    const unselectMedicalInfo = response?.packageServiceMedicalInfo?.filter(
      (item) => !item?.isIncluded
    )
    dispatch(setPostUnselectedMedicalInfoAction(unselectMedicalInfo || null))

    // Set Optional Medical Info
    dispatch(setPostOptionalMedicalInfoAction(response?.optionalMedicalInfo || null))
  } else {
    dispatch(setPostPackageIdsAction(null))
    dispatch(setPostAdditionalServicesAction(null))
    dispatch(setPostOptionalAdditionalInfoAction(null))
    dispatch(setPostOptionalMedicalInfoAction(null))
    dispatch(setPostUnselectedAdditionalInfoAction(null))
    dispatch(setPostUnselectedMedicalInfoAction(null))
    dispatch(setPostUnselectedPackageServicesAction(null))
  } 

  // Set Package Ids
  dispatch(
    setPackageIdsAction(
      response?.packages?.map((item) => ({
        ...item,
        id: item?.packageId,
        value: item?.packageId,
        label: item?.name,
        project: item?.project || null
      }))
    )
  )

  // Set Unselected Package Services
  const unselectPackageService = response?.services?.packageServices?.filter(
    (item) => !item?.isIncluded
  )

  const mappingUnselectPackageService = unselectPackageService?.map(
    (item) => ({
      ...item,
      packageCategory: response?.packages?.find(
        (packageItem) => packageItem?.packageId === item?.packageId
      )?.packageCategory,
      projectId: response?.packages?.find(
        (packageItem) => packageItem?.packageId === item?.packageId
      )?.project?.id || null
    })
  )

  dispatch(setUnselectedPackageServicesAction(mappingUnselectPackageService || []))

  let services = (response?.services?.additionalServices || [])?.map((item) => ({
    ...item,
    value: item?.id,
    label: item?.name,
    type: 'general'
  }))

  let additionalServices = (response?.services?.projectAdditionalServices || [])?.map((item) => ({
    ...item,
    value: item?.id,
    label: item?.name,
    type: 'project'
  })) 

  let mergeServicesAndAdditionalServices = services?.concat(additionalServices)

  // Set Additional Services
  dispatch(setAdditionalServicesAction(mergeServicesAndAdditionalServices || []))

  // Set Unselected Additional Info
  const unselectAdditionalInfo = response?.packageServiceAdditionalInfo?.filter(
    (item) => !item?.isIncluded
  )
  dispatch(setUnselectedAdditionalInfoAction(unselectAdditionalInfo || []))

  // Set Optional Additional Info
  dispatch(setOptionalAdditionalInfoAction(response?.optionalAdditionalInfo))

  // Set Unselected Medical Info
  const unselectMedicalInfo = response?.packageServiceMedicalInfo?.filter(
    (item) => !item?.isIncluded
  )
  dispatch(setUnselectedMedicalInfoAction(unselectMedicalInfo || []))

  // Set Optional Medical Info
  dispatch(setOptionalMedicalInfoAction(response?.optionalMedicalInfo || []))
}

export const clearPackageServiceAction = () => (dispatch) => {
  dispatch(setPackageIdsAction([]))
  dispatch(setAdditionalServicesAction([]))
  dispatch(setUnselectedPackageServicesAction([]))
  dispatch(setUnselectedAdditionalInfoAction([]))
  dispatch(setOptionalAdditionalInfoAction([]))
  dispatch(setUnselectedMedicalInfoAction([]))
  dispatch(setOptionalMedicalInfoAction([]))
  
  dispatch(setPostPackageIdsAction(null))
  dispatch(setPostAdditionalServicesAction(null))
  dispatch(setPostOptionalAdditionalInfoAction(null))
  dispatch(setPostOptionalMedicalInfoAction(null))
  dispatch(setPostUnselectedAdditionalInfoAction(null))
  dispatch(setPostUnselectedMedicalInfoAction(null))
  dispatch(setPostUnselectedPackageServicesAction(null))
}

